module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-roadmap-to-success"
  }, [_c('div', {
    staticClass: "jumbo-wrapper roadmap-to-success"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("ROADMAP TO SUCCESS")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    STEP-BY-STEP\n                    "), _c('br'), _vm._v("\n                    PROJECT GUIDE\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("We’ve broken down what you need.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('div', {
    staticClass: "row checkbox-list"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        EVERYTHING YOU NEED\n                        "), _c('br'), _vm._v("\n                        AT YOUR FINGERTIPS\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        FREE PRODUCT GRAPHICS\n                        "), _c('br'), _vm._v("\n                        FOR YOUR MARKETING\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-4 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        TIPS, TRICKS & EXTRAS TO\n                        "), _c('br'), _vm._v("\n                        CUSTOMIZE YOUR PROJECT\n                    ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        SUCCESS IN 6 STEPS!\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Our Roadmap to Success breaks down\n                        the entire process of an Engraved Brick\n                        Project into 6 steps, from conception\n                        through installation. We guide you\n                        through your options, what you need,\n                        and when. Our goal is to make the\n                        process easy to manage and as\n                        streamlined as possible.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "298",
      "src": "images/Roadmap-To-Success/roadmaptosuccess01.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "298",
      "src": "images/Roadmap-To-Success/roadmaptosuccess02.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        FREE ENGRAVED BRICK SAMPLE\n                        FOR DISPLAY & MARKETING\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Displaying a brick helps donors envision\n                        their own brick and message which builds\n                        excitement.\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "body-area-list probe"
  }, [_c('li', [_c('span', [_vm._v("Your Personalized Inscription")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Sample in Your Chosen Material(s)")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Display at Your Facility or Booth")])])])])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        FREE RESOURCES\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Our Roadmap includes an extensive\n                        reference section which provides additional\n                        information to create a complete\n                        fundraising solution\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "body-area-list"
  }, [_c('li', [_c('span', [_vm._v("Marketing Templates")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Digital Asset Library")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Installation & Layout Examples")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Project Companion")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Checklists")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("... and More!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "401",
      "src": "images/Roadmap-To-Success/roadmaptosuccess03.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "450",
      "height": "356",
      "src": "images/Roadmap-To-Success/roadmaptosuccess04.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        TIPS & TRICKS\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Compiled from our 32+ years in the\n                        industry, each step includes ways to\n                        take your project to the next level and\n                        customize it for your organization and\n                        donors.\n                    ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332e2250","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/RoadmapToSuccess.vue
// module id = 47fr
// module chunks = 1